// bm-design-system: date input primitive
import * as React from "react";
import { cn } from "@/lib/utils";

export interface DateInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="date"
        className={cn("form-control", className)}
        {...props}
      />
    );
  },
);
DateInput.displayName = "DateInput";

export { DateInput };
